export const environment = {
  production: false,
  host: 'https://mavens-api.interg.co.id',
};
